import { UpdateKinds } from "../UpdateKinds";
import { ExternalSubItem } from "./ExternalSubItem";
import { IItem } from "./IItem";
import { RelationalActionParameter } from "./RelationalActionParameter";

export interface IExternalScriptExecutable extends IItem {
  name: string;
  exePath: string;
  csvPath: string;
  xmlValuePath: string;
  csvBeforeValuePath: string;
  csvInputValuePath: string;
  updateKind: UpdateKinds;
  splitter: string;
  items: ExternalSubItem[];
  actions: RelationalActionParameter[];
  previousCsvBinary: string;
}

export function instanceOfIExternalScriptExecutable(instance: any): instance is IExternalScriptExecutable {
  return instance
    && (instance.updateKind !== undefined);
}
